function summaryWA (payload) {
    var WA = `\n\nEstimado/a ${payload.patient_first_name}:\nGracias por su asistencia a la consulta con ${payload.doctor_name}\nUsted es muy importante para nosotros y nuestro objetivo es atenderlo de la mejor manera posible.\n\nEn el siguiente link puede revisar la receta de sus medicamentos o las instrucciones del doctor.\n\nInstrucciones del doctor:\n\n ${payload.instructions}`
    return WA
}

export {summaryWA}